"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconDatabase = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M64 22.83V11.17c0-6.33-27.79-6.41-29-6.41S6 4.84 6 11.17v11.66c0 1.26 1.16 2.28 3 3.09-1.84.82-3 1.83-3 3.08v11.68c0 1.25 1.1 2.26 2.86 3.07C7.13 44.56 6 45.56 6 46.82v11.66c0 6.33 27.79 6.4 29 6.4s29-.07 29-6.4V46.82c0-1.26-1.1-2.26-2.86-3.07 1.76-.81 2.86-1.82 2.86-3.07V29c0-1.27-1.13-2.28-2.92-3.1 1.76-.79 2.92-1.81 2.92-3.07zm-2.49-.08c-.63 1.43-10 4-26.48 4s-25.88-2.57-26.5-3.92v-8.76c6.85 3.45 25.47 3.5 26.47 3.5s19.62-.05 26.47-3.5zm0 17.85c-.63 1.43-10 4-26.48 4S9.15 42 8.53 40.68v-8.76c6.85 3.45 25.47 3.5 26.47 3.5s19.62-.05 26.47-3.5zm0 17.8c-.63 1.43-10 4-26.48 4s-25.88-2.57-26.5-3.92v-8.76c6.85 3.45 25.47 3.5 26.47 3.5s19.62 0 26.47-3.5zm0-11.58c-.93 1.44-10.28 3.9-26.44 3.9s-25.58-2.46-26.51-3.9c.33-.52 1.77-1.17 4.21-1.79 8.3 2 21.43 2 22.23 2s13.93 0 22.23-2c2.44.62 3.88 1.27 4.21 1.79zm0-17.8c-.93 1.44-10.28 3.9-26.44 3.9S9.49 30.46 8.56 29c.34-.53 1.81-1.19 4.31-1.82 8.31 2 21.33 2 22.13 2s13.82 0 22.13-2c2.5.65 3.97 1.31 4.31 1.82zm0-17.85c-.93 1.44-10.28 3.9-26.44 3.9s-25.58-2.46-26.51-3.9C9.49 9.73 18.84 7.26 35 7.26s25.51 2.47 26.44 3.91z"
  })),
  height: undefined,
  width: undefined
});
IconDatabase.displayName = 'IconDatabase';
var _default = IconDatabase;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/database.js
// module id = 336
// module chunks = 0